module.exports = __webpack_public_path__ + "static/media/pagedwn.d0a2f321.svg";